<img [src]="icon" [hidden]="!showCheckIcon" class="check-icon">